module.exports = __webpack_public_path__ + "static/media/small1.21529d03.png";